export const Close = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{ width: '100%' }}
		data-testid="svgClose"
		{...props}
	>
		<path
			d="M6.969 4.5094C6.2898 3.8302 5.1886 3.8302 4.5094 4.5094C3.8302 5.1886 3.8302 6.2898 4.5094 6.969L9.5404 12L4.5094 17.031C3.8302 17.7102 3.8302 18.8114 4.5094 19.4906C5.1886 20.1698 6.2898 20.1698 6.969 19.4906L12 14.4596L17.031 19.4906C17.7102 20.1698 18.8114 20.1698 19.4906 19.4906C20.1698 18.8114 20.1698 17.7102 19.4906 17.031L14.4596 12L19.4906 6.969C20.1698 6.2898 20.1698 5.1886 19.4906 4.5094C18.8114 3.8302 17.7102 3.8302 17.031 4.5094L12 9.5404L6.969 4.5094Z"
			fill="currentColor"
		/>
	</svg>
);
